import React, { createContext, useState, useMemo, useContext, useEffect } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';


// brand colors 
const BRAND_COLORS = {
  primary: '#016fffff', // Company's primary blue
  secondary: '#34a853', // Example secondary color
};

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: BRAND_COLORS.primary },
    secondary: { main: BRAND_COLORS.secondary },
    background: { default: '#f7f9fc', paper: '#ffffff' },
    text: { primary: 'rgba(0, 0, 0, 0.87)', secondary: 'rgba(0, 0, 0, 0.6)' }
  },
  shape: { borderRadius: 8 },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#90caf9' }, // A lighter blue for dark mode
    secondary: { main: '#81c784' },
    background: { default: '#202124', paper: '#2d2e30' },
    text: { primary: '#e8eaed', secondary: '#9e9e9e' },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  shape: { borderRadius: 8 },
});

// CONTEXT AND PROVIDER 
export const ThemeContext = createContext({
  toggleTheme: () => {},
});

export const AppThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => localStorage.getItem('themeMode') || 'light');

  useEffect(() => {
    localStorage.setItem('themeMode', mode);
    
    document.documentElement.style.setProperty(
      '--logo-light-display',
      mode === 'light' ? 'block' : 'none'
    );
    document.documentElement.style.setProperty(
      '--logo-dark-display',
      mode === 'dark' ? 'block' : 'none'
    );
  }, [mode]);

  const themeToggle = useMemo(
    () => ({
      toggleTheme: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    []
  );

  const theme = useMemo(() => (mode === 'light' ? lightTheme : darkTheme), [mode]);

  return (
    <ThemeContext.Provider value={themeToggle}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeToggle = () => {
  return useContext(ThemeContext);
};
